export default "__VITE_ASSET__Bkk3AzLn__"